var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspnBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 52,
    viewBox: "0 0 244 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2456_61010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2926 22.9026C63.5624 22.9026 46.7498 22.8961 43.3348 22.8961C42.6025 27.6946 45.0034 29.8655 48.4087 29.8655C50.262 29.8655 61.9327 29.859 61.9327 29.859L61.5115 33.3064H42.0582L41.0797 41.2866C41.0797 41.2866 62.2567 41.2931 63.1153 41.2866C63.8216 41.2348 68.7789 41.102 70.4638 37.0487C71.0113 35.7332 71.4941 31.0157 71.6302 30.0275C72.411 24.2764 68.429 22.9058 65.2926 22.9058V22.9026Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.044 41.2866L131.043 41.2802L133.301 22.8993L123.306 22.8929L121.044 41.2866Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4544 29.8655L41.3097 22.8961H14.5858L12.3242 41.2866H39.0514L40.0364 33.3064H23.3015L23.7227 29.8655H40.4544Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.544 11.2578H105.741L104.708 19.6852H133.687C133.687 19.6852 133.723 19.3806 133.849 18.3892C134.559 12.8584 130.991 11.2578 127.544 11.2578Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4523 22.8961L72.1939 41.2866H82.1863L83.5957 29.8655H96.1477C99.7052 29.8655 101.62 27.9506 101.977 25.3812C102.155 24.0852 102.284 22.8961 102.284 22.8961H74.4523Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.871 18.117C103.315 14.5206 101.785 11.2578 96.2254 11.2578C96.2254 11.2578 54.3736 11.2578 51.9857 11.2578C47.4529 11.2513 44.4558 13.6393 44.0314 17.2098C43.8759 18.5253 43.7268 19.6852 43.7268 19.6852H102.673C102.673 19.6852 102.783 18.8136 102.871 18.117Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.054 41.2866L112.05 41.2802L114.311 22.8993L104.309 22.8929L102.054 41.2866Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7386 11.2578H16.0114L14.9778 19.6852H41.7083L42.7386 11.2578Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.824 11.2578H142.721L139.082 41.2802C139.082 41.2802 160.424 41.2866 161.289 41.2802C161.999 41.2283 166.901 41.1797 168.628 37.1102C169.189 35.7883 169.62 32.1076 169.762 31.1129C170.112 28.699 168.822 27.3026 167.536 26.4893C167.251 26.3111 167.319 25.8769 167.643 25.7927C169.001 25.4428 170.281 24.7202 170.63 23.1812C170.877 22.099 171.113 19.7208 171.282 18.3989C172.046 12.8487 168.317 11.2611 164.824 11.2611V11.2578ZM163.969 30.1732L163.554 33.504C163.376 35.056 162.18 36.028 160.528 36.1382H145.663L146.518 28.9615H163.062C164.173 28.9615 163.972 30.1732 163.972 30.1732H163.969ZM165.599 17.644L165.184 20.9747C165.006 22.5267 163.81 23.4987 162.158 23.6089H147.292L148.148 16.4322H164.691C165.9 16.4322 165.602 17.644 165.602 17.644H165.599Z",
    fill: "#20F4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.398 16.4322L202.01 11.2708H175.708L172.014 41.2802H198.32L198.932 36.0863L178.682 36.1544L179.664 28.9615H196.706L197.328 23.6802H180.315L181.284 16.4322H201.398Z",
    fill: "#20F4CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.133 11.2708H205.182L204.564 16.4646H215.065L211.99 41.2802H217.942L221.049 16.4646H231.521L232.133 11.2708Z",
    fill: "#20F4CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2456_61010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 30.1325,
    fill: "white",
    transform: "translate(12 10.9338)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspnBet);
export default __webpack_public_path__ + "static/media/espn_bet.9c24a38cc4cef8d979f003eaa7be8379.svg";
export { ForwardRef as ReactComponent };